import { defineStore } from "pinia";
import { IUmbracoForm } from "@/models/umbraco-forms/IUmbracoForm";
import { UmbracoFormsApi } from "@/services/Api";

let workingQueue: Array<string> = [];
export const useUmbracoForm = defineStore("umbraco-forms", {
  state: () => {
    return {
      state: {},
    };
  },
  actions: {
    async get(id: string): Promise<IUmbracoForm | undefined> {
      if (!workingQueue.some((x) => x == id)) {
        workingQueue.push(id);
        try {
          let definition = this.$state[id];
          if (definition) {
            return definition;
          }
          definition = await UmbracoFormsApi.get(id);
          this.state[id] = { ...definition };
          return definition;
        } catch {
          return undefined;
        } finally {
          workingQueue = workingQueue.filter((x) => x != id);
        }
      }
    },
  },
});
